import React, { useState, useEffect, Fragment, useRef } from "react";
import { AlarmData } from "../Common/Types/types";
import { useDispatch, useSelector } from "react-redux";
import { getParamsSelector, updateParams } from "../Common/Slices/ParamSlice";
import Spinner from "../Common/Components/spinner";
import ErrorMessage from "../Common/Components/ErrorMessage";
import { useAppDispatch } from "../Core/store.hooks";
import { getAlarmsLoadingSelectorWithScope, getAlarmsWithScopeSelector } from "./Slice";
import AlarmComboChart from "../Common/Components/Charts/ComboChart";
import FormatAlarms from "./FormatAlarms";
import { getDevicesSelector} from "../Devices/Slice"
import { alarmOptions, getOptionsSelector } from "../Common/Slices/optionSlice";
import { getMachineTimesLoadingSelector, getMachineTimesSelector } from "../MachineTimes/slice";
import { paramsById } from "../Common/Util_methods/scope";
import { orderBy } from "lodash";

interface AlarmScopeChartWidgetProps {
    id: string;
    header: string;
    values: string;
    series: {
        name:string,
        unit:string,
        color:string
        }
}

const AlarmScopeChartWidget = (props: AlarmScopeChartWidgetProps) => {
    const [chartData, updateChartData] = useState([]);
    const [combined,setCombined] = useState<boolean>(false);
    const [dataProcessed, setDataProcessed] = useState(false);

    const dispatch = useAppDispatch();

    const options = useSelector(getOptionsSelector)
    const deviceObjects = useSelector(getDevicesSelector)
    const params = useSelector(getParamsSelector)
    const alarms = useSelector(getAlarmsWithScopeSelector);
    const machineTimes = useSelector(getMachineTimesSelector)
    const loadingState = useSelector(getAlarmsLoadingSelectorWithScope);
    const timesLoadingState = useSelector(getMachineTimesLoadingSelector);

    const scopeChartRef = useRef(null);

    useEffect(()=>{
        
        if(loadingState === "pending"){
            setDataProcessed(false);
        }
        if(loadingState === "rejected"){
            setDataProcessed(true);
        }
        if(loadingState === "fulfilled" && alarms.length === 0){
            setDataProcessed(true);
        }
    },[loadingState])

    useEffect(()=>{
        if(options.machineTimesVisibility === true && loadingState !== "pending" && timesLoadingState !== "pending"){
            if(machineTimes.length > 0 && alarms.length > 0 ){
                const combinedData = combineData();
                const sortedData = sortData(combinedData)
                updateChartData(sortedData);
                setCombined(true)
            }else{
                updateChartData([])
            }
            setDataProcessed(true);
        }
    },[options.machineTimesVisibility,options.alarmChartSortOrder,options.chartItemNumber,machineTimes,alarms])

    useEffect(()=>{
        if(options.machineTimesVisibility === false && loadingState !== "pending"){
            updateChartData(sortData(alarms));
            setCombined(false)
            setDataProcessed(true);
        }
    },[options.machineTimesVisibility,options.alarmChartSortOrder,options.chartItemNumber,alarms])

    // useEffect(()=>{
    //     if(scopeChartRef.current && options.machineTimesVisibility === true){
    //         scopeChartRef.current.scrollIntoView({ behavior: 'smooth'});
    //     }
    // },[options.machineTimesVisibility]);

    const combineData = () =>{
        let combinedData = []
        for(let i=0; i<alarms.length; i++) {
            combinedData.push({
             ...alarms[i], 
             ...(machineTimes.find((itmInner) => itmInner.id === alarms[i].id))},
            );
        }
        return combinedData;
    }

    const sortData = (data:AlarmData[]) => {
        let sortedData = data;
        const dataInHours = FormatAlarms.durationInHours(data);
        if(options.alarmChartSortOrder === "Count / Duration"){
            sortedData = orderBy(dataInHours,props.values,"desc");
        }else if(props.values === "count"){
            sortedData = orderBy(dataInHours,"countPerShiftHours","desc");
        }else if(props.values === "duration"){
            sortedData = orderBy(dataInHours,"durationPerShiftHours","desc");
        }
        return sortedData;
    }

    const handleChartClick = (id:string) =>{  
        if (id != null){
            const newParams = paramsById(params,options,deviceObjects,id)
            if(newParams !== null){
                dispatch(updateParams(newParams))
            }
        }
    }
    
    if (!dataProcessed) return <Spinner text="data" />;
    if (chartData == null  || loadingState === "rejected") {
        //proper error handling should be added with promise error response
        return (
            <ErrorMessage
                text={"Oops something went wrong, unable to get data."}
                id={props.id}
                header={props.header}
            />
        );
    }   
    if (chartData != null && chartData.length === 0) {
        return (
            <ErrorMessage
                text={"No data found for selected filters."}
                id={props.id}
                header={props.header}
            />
        );
    }
    return (<div ref={scopeChartRef} style={{width:"100%", height:"100%"}}>
            <AlarmComboChart 
                type="alarms" 
                combined={combined} 
                clickHandler={handleChartClick} 
                id={props.id} 
                category="text" 
                data={chartData} 
                values={props.values} 
                series={props.series}
                itemNumber={options.chartItemNumber}
            />
        </div>
        );
    //return <AlarmComboChart type={type} clickHandler={handleChartClick} id={props.id} data={chartData} values={props.values} series={props.series}/>
};
export default AlarmScopeChartWidget;
